import { useEffect, useState } from "react";
import ChildComponentLegacy from "../../../components/applicationComponents/legacy/child/ChildComponentLegacy";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";

export default function ApplicationProviderViewLegacy() {
  const [loaded, setLoaded] = useState(false);

  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "View Application",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  const { applicationBase, rehydrate } = useApplicationContext();
  useEffect(() => {
    rehydrate().then(() => {
      setLoaded(true);
    });
  }, []);

  return (
    <div className="w-full">
      {loaded && (
        <div className="flex flex-column align-items-start w-full height-calc">
          <ChildComponentLegacy disabled={true} data={applicationBase.child} />
        </div>
      )}
    </div>
  );
}
